export default __webpack_public_path__ + "static/media/bg.0be44e86.svg";